<template>
  <header ref="page-header" class="tw:flex tw:flex-row tw:justify-between tw:bg-white tw:shadow-lg tw:items-center">
    <Logo class="tw:ml-4" />
    <LanguageSelector size="big" class="tw:mr-4" version="footer" />
  </header>
</template>
<script setup>
import LanguageSelector from '@/components/locale/LanguageSelector.vue'
import Logo from '@/components/dashboard/Logo.vue'
</script>
